import React, { Component } from 'react';
import ValidatingImageInput from './ValidatingImageInput'
import FieldLevelHelp from '../components/FieldLevelHelp';

class ImageUpload extends Component {
    render() {

        return (
            <div>
            	<div className="row upload-row">
	            	<div className="col-md-12">
                        <p>
                            Upload Insurance and ID cards in <b>JPEG</b>, <b>PNG</b>, or <b>GIF</b> file format. <br/> If you're using a mobile device, you may take a picture of the front/back of your card, and upload it here.
                        </p>

		            </div>
	            </div>
                {/*
                    If you change the 'type' attribute/prop passed to ValidatingImageInput, you will need to update CARD_IMG_TYPES
                    in GEAR class com.gdx.gear.requisition.controller.AttachmentController
                */}
                <div className="row upload-row">
                    <h4>Primary Insurance<FieldLevelHelp helpText="<b>How do I upload a copy of my card?</b><br/>If you're using a mobile device, you may take a picture of the front/back of your insurance card, and upload it here." trigger="hover" large={true} html={true}/></h4>
                    <div className="col-md-5 offset-md-1">
                        <ValidatingImageInput type="ins-primary-front" showUploadError={this.props.showUploadError} gearOrder={this.props.gearOrder} label="Front of Card" addUploadedImage={this.props.addUploadedImage} removeUploadedImage={this.props.removeUploadedImage} />
                    </div>
                    <div className="col-md-5">
                        <ValidatingImageInput type="ins-primary-back" showUploadError={this.props.showUploadError} gearOrder={this.props.gearOrder} label="Back of Card" addUploadedImage={this.props.addUploadedImage} removeUploadedImage={this.props.removeUploadedImage} />
                    </div>
                </div>
                <hr/>
                <div className="row upload-row">

                	<h4>Secondary Insurance<FieldLevelHelp helpText="<b>How do I upload a copy of my card?</b><br/>If you're using a mobile device, you may take a picture of the front/back of your insurance card, and upload it here." trigger="hover" large={true} html={true}/></h4>

                	<div className="col-md-5 offset-md-1">
                        <ValidatingImageInput type="ins-secondary-front" showUploadError={this.props.showUploadError} gearOrder={this.props.gearOrder} label="Front of Card" addUploadedImage={this.props.addUploadedImage} removeUploadedImage={this.props.removeUploadedImage} />
                    </div>
                    <div className="col-md-5">
                        <ValidatingImageInput type="ins-secondary-back" showUploadError={this.props.showUploadError} gearOrder={this.props.gearOrder} label="Back of Card " addUploadedImage={this.props.addUploadedImage} removeUploadedImage={this.props.removeUploadedImage} />
                    </div>

                </div>
                <hr/>
                <div className="row upload-row">
                    <h4>Drivers License <small>or other Govt. issued photo ID</small></h4>

                    <div className="col-md-5 offset-md-1">
                        <ValidatingImageInput type="gov-id-front" showUploadError={this.props.showUploadError} gearOrder={this.props.gearOrder} label="ID Front" addUploadedImage={this.props.addUploadedImage} removeUploadedImage={this.props.removeUploadedImage} />
                    </div>

                    <div className="col-md-5">
                        <ValidatingImageInput type="gov-id-back" showUploadError={this.props.showUploadError} gearOrder={this.props.gearOrder} label="ID Back" addUploadedImage={this.props.addUploadedImage} removeUploadedImage={this.props.removeUploadedImage} />
                    </div>
                </div>
            </div>
        )
    }
}

export default ImageUpload;
